export default {"src":"/_next/static/media/up-down.4f0b0333.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};